import {h, Component, Fragment} from "preact";
import {ThreeDots} from "./prematch-tournament.jsx";

import formatOdd from "../../../services/odds-format";

export {ThreeDots} from "./prematch-tournament.jsx";

export function TitleHeader({children}) {
	return <div class="cl-pse-ttl-head flex rounded-t-lg h-10 items-center bg-kobaaccent-400 text-slate-950">{children}</div>
}
export function BackButton({children, onClick}) {
	return <div class="cl-pse-backbtn flex h-10 w-9 flex-none items-center justify-center text-slate-950 pb-0.5 cursor-pointer hover:text-kobaaccent-500" onClick={onClick}>{children}</div>
}

export function SportName({children}) {
	return <div class="cl-pse-sport-name min-w-0 truncate text-base text-slate-950">{children}</div>
}
export function TournamentName({children}) {
	return <div class="cl-pse-tourn-name min-w-0 grow truncate px-4 text-base">{children}</div>
}
export function MatchNameBreadcrumb({children}) {
	return <span class="cl-pse-mtch-name-bread text-base text-slate-950 font-bold">{children}</span>
}

export function PrematchEventNameRow({children}) {
	return <div class="cl-pse-pevt-name-row fn-live-event-header border-b border-b-slate-300 bg-slate-100 p-2 px-3 text-slate-950">{children}</div>
}
export function InfoBox({children}) {
	return <div class="cl-pse-infobox flex h-full items-center">{children}</div>
}
export function TournamentBaseInfo({children}) {
	return <div class="cl-pse-trn-baseinfo text-sm">{children}</div>
}
export function EventFullName({children}) {
	return <div class="cl-pse-evt-fullname truncate">{children}</div>
}
export function EventBaseInfo({children}) {
	return <div class="cl-pse-evt-baseinfo flex min-w-0 grow flex-col justify-between">{children}</div>
}

export function EventRapidButtons({children}) {
	return <div class="cl-pse-evt-rpd-btns flex flex-none">{children}</div>
}
export function EventRapidButtonLeft({children, active, onClick}) {
	return <div class="cl-pse-evt-rpd-btn-l flex h-8 w-8 items-center justify-center border border-r-0 border-zinc-900" onClick={onClick}>{children}</div>
}
export function EventRapidButtonRight({children, active, onClick}) {
	return <div class="cl-pse-evt-rpd-btn-r flex h-8 w-8 items-center justify-center border border-zinc-900" onClick={onClick}>{children}</div>
}

export function ScrollableTabsRail({children}) {
	return <div class="cl-pse-scroll-tab-rail scrollbar-x-fancy relative overflow-x-auto overflow-y-hidden rounded-b-lg bg-slate-100 border-b border-b-slate-300">{children}</div>
}
export function ScrollableTabsContent({children}) {
	return <div class="cl-pse-scroll-tab-cont fn-tabs flex gap-2 p-3 text-sm">{children}</div>
}
export function TabButton({children, active, onClick, ...props}) {
	if (active)
		return <div 
				   class={"cl-pse-tab-btn flex h-8 shrink-0 grow items-center justify-center rounded-full border border-kobaaccent-400 bg-kobaaccent-400 text-slate-950 w-fit px-3 cursor-pointer "+(props['class'] || '')} 
				   onClick={onClick}>
			<span class="truncate">{children}</span>
		</div>
	return <div 
			   class={"cl-pse-tab-btn flex h-8 shrink-0 grow items-center justify-center rounded-full border border-slate-300 bg-slate-100 text-slate-950 w-fit px-3 cursor-pointer "+(props['class'] || '')}
			   onClick={onClick}>
		<span class="truncate">{children}</span>
	</div>
}

export function MarketsContainer({children}) {
	return <div class="cl-pse-mkt-cont fn-market overflow-x-hidden rounded-lg my-3">{children}</div>
}
export function MarketHeadRow({children, onClick}) {
	return <div class="cl-pse-mkt-head-row flex h-10 items-center bg-slate-200 text-slate-950 cursor-pointer hover:bg-slate-300" onClick={onClick}>{children}</div>
}
export function MarketCollapseButton({children, active, onClick}) {
	return <div class="cl-pse-mkt-coll-btn flex h-7 w-9 flex-none items-center justify-center pb-0.5" onClick={onClick}>{children}</div>
}
export function MarketName({children}) {
	return <div class="cl-pse-mkt-name min-w-0 grow truncate px-4 text-sm">{children}</div>
}

export function OutcomesContainer({children, open}) {
	if (!open)
		return <div class="cl-pse-out-cont -mx-px text-sm hidden">{children}</div>
	return <div class="cl-pse-out-cont -mx-px flex flex-col gap-2 text-sm bg-slate-100 p-4">{children}</div>
}
export function OutcomesContainerRow({children, cols}) {
	return <div class={"cl-pse-out-cont-row grid gap-2 "+(cols == 3 ? "grid-cols-3 gap-2" : "grid-cols-2 gap-2")}>{children}</div>
}

export function OutcomeButton({value, active, onClick, selected, children}) {
	if (selected)
		return <div 
				   class="cl-pse-out-btn flex h-11 leading-none grow flex flex-col items-center justify-center rounded-3xl overflow-hidden border border-kobaaccent-400 text-slate-950 bg-kobaaccent-400 cursor-pointer"
				   onClick={onClick}>
			{children}
		</div>
	return <div 
			   class="cl-pse-out-btn flex h-11 leading-none grow flex flex-col items-center justify-center rounded-3xl overflow-hidden border border-kobaaccent-400 bg-slate-100 hover:bg-kobaaccent-400 cursor-pointer"
			   onClick={onClick}>
		{children}
	</div>
}
export function OutcomeBuilderButton({value, active, onClick, selected, disabled, children}) {
	if (disabled)
		return <div 
				   class="cl-pse-out-btn flex h-11 leading-none grow flex flex-col items-center justify-center rounded-3xl overflow-hidden border border-slate-400 text-slate-950 bg-slate-400 cursor-pointer" 
				   onClick={onClick}>
			{children}
		</div>
	if (selected)
		return <div 
				   class="cl-pse-out-btn flex h-11 leading-none grow flex flex-col items-center justify-center rounded-3xl overflow-hidden border border-kobaaccent-400 text-slate-950 bg-kobaaccent-400 cursor-pointer" 
				   onClick={onClick}>
			{children}
		</div>
	return <div 
			   class="cl-pse-out-btn flex h-11 leading-none grow flex flex-col items-center justify-center rounded-3xl overflow-hidden border border-kobaaccent-400 bg-slate-100 hover:bg-kobaaccent-400 cursor-pointer"
			   onClick={onClick}>
		{children}
	</div>
}
export function OutcomeName({children}) {
	return <span class="cl-pse-out-name h-4 px-4 min-w-0 max-w-full truncate text-sm text-slate-950">{children}</span>
}
export function OutcomeValue({value, selected}) {
	if (selected)
		return <span class="cl-pse-out-value h-4 text-slate-950 text-sm">{!!value ? formatOdd(value) : '-'}</span>
	return <span class="cl-pse-out-value h-4 text-slate-950 text-sm">{!!value ? formatOdd(value) : '-'}</span>
}

export function EventContent() {
	return <div>
	  <TitleHeader>
		<BackButton>B</BackButton>
		<ThreeDots />
		<SportName>Football</SportName>
		<TournamentName>Region - Tournament / <MatchNameBreadcrumb>Home vs. Away</MatchNameBreadcrumb></TournamentName>
	  </TitleHeader>

	  <PrematchEventNameRow>
		<InfoBox>
		  <EventBaseInfo>
			<TournamentBaseInfo>Nike FC Cup - Women</TournamentBaseInfo>
			<EventFullName>Nike FC Cup - Women</EventFullName>
		  </EventBaseInfo>
		  <EventRapidButtons>
			<EventRapidButtonLeft />
			<EventRapidButtonRight />
		  </EventRapidButtons>
		</InfoBox>
	  </PrematchEventNameRow>

	  <ScrollableTabsRail>
		<ScrollableTabsContent>
		  <TabButton>Tab</TabButton>
		  <TabButton>Tab</TabButton>
		  <TabButton>Tab</TabButton>
		</ScrollableTabsContent>
	  </ScrollableTabsRail>

	  <div>
		<MarketsContainer>
		  <MarketHeadRow>
			<MarketCollapseButton>B</MarketCollapseButton>
			<MarketName>Market Name</MarketName>
		  </MarketHeadRow>

		  <OutcomesContainer>
			<OutcomeButton>
			  <OutcomeName>Outcome</OutcomeName>
			  <OutcomeValue>3.10</OutcomeValue>
			</OutcomeButton>
			<OutcomeButton>
			  <OutcomeName>Outcome</OutcomeName>
			  <OutcomeValue>3.10</OutcomeValue>
			</OutcomeButton>
			<OutcomeButton>
			  <OutcomeName>Outcome</OutcomeName>
			  <OutcomeValue>3.10</OutcomeValue>
			</OutcomeButton>
		  </OutcomesContainer>
		</MarketsContainer>
	  </div>
	</div>
}
